@import '~style-sheet-helpers/core.less';

.edit-columns-button {
  cursor: pointer;
  margin: 5px 0;
}
